import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {SegurosTiposPersonas} from '../_models/seguros-tipos-personas';
import {ProductosFlujoVentaPasosTiposPersonas} from '../_models/productos-flujo-venta-pasos-tipos-personas';

@Injectable({
  providedIn: 'root'
})
export class ProductosFlujoVentaPasosTiposPersonasService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosFlujoVentaPasosTiposPersonas';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductosFlujoVentaPasosTiposPersonas[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductosFlujoVentaPasosTiposPersonas[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductosFlujoVentaPasosTiposPersonas ) );
  }

  listadoPorIdProductoFlujoVentaPaso( id: string ) {
    return this.httClient.get( this.rutServicio + '/idProductoFlujoVentaPaso/' + id ).pipe( map( res => res as ProductosFlujoVentaPasosTiposPersonas[] ) );
  }

  crear( regCrear: ProductosFlujoVentaPasosTiposPersonas ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductosFlujoVentaPasosTiposPersonas ) );
  }

  actualizar( regActualizar: ProductosFlujoVentaPasosTiposPersonas ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as ProductosFlujoVentaPasosTiposPersonas ) );
  }

  bulk( registros: ProductosFlujoVentaPasosTiposPersonas[] ) {
    registros.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( `${ this.rutServicio }/bulk`, registros ).pipe( map( res => res as ProductosFlujoVentaPasosTiposPersonas[] ) );
  }
}
